import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { logoutRoute } from 'routes/routeNames'

const Route401 = () => {
  const { t } = useTranslation()
  const errorMessage = t('global.not_authorized')

  return (
    <div>
      <div>{errorMessage}</div>
      <NavLink to={logoutRoute} data-testid='error-item-logout'>
        {t('global.menu_logout')}
      </NavLink>
    </div>
  )
}

export default Route401
